export default __webpack_public_path__ + "static/media/jezowka.2e9a1ce0.svg";